import { Pages } from '@/lib/app-links';
import { authClient } from '@/lib/auth-client';

interface SignOutRouter {
  replace(href: string): void;
}

export async function signOutAndRedirect(router: SignOutRouter): Promise<void> {
  const { error } = await authClient.signOut();
  if (error) {
    return;
  }

  router.replace(Pages.signin);
}
